const soundDetailStar = async() => {
  const path = `../assets/sound/extend/description_star.m4a`;    
  var audio = new Audio(path);    
  audio.volume = 0.3;  
  audio.play();
}

export default soundDetailStar;